import { globalStyleSheet } from "@/assets/css/global";
import '@/components/reusable/RPlayButton';
import { player } from "@/utils/player";
import repeatAllIcon from '@/assets/images/repeat_all.svg';
import repeatCurrent from '@/assets/images/repeat_one.svg';
import { eventEmitter } from "@/utils/eventEmitter";
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
      display: flex;
    }
    
    :host(:state(none)) r-icon {
        color: lightgray;
    }
    
    :host(:state(all)) #all {
        color: var(--color-player-button);
    }
    
    :host(:state(current)) #current {
        display: revert-layer;
        color: var(--color-player-button);
    }
    
    #current, :host(:state(current)) #all {
        display: none;
    }
    
    button {
        outline: none;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        width: 36px;
        height: 36px;
    }
    
    r-icon {
        width: 100%;
        height: 100%;
    }
`);
export class RPlayerRepeatButton extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#abortController = new AbortController();
        this.#initDOM();
        this.#processRepeatChange();
    }
    disconnectedCallback() {
        this.#abortController.abort();
    }
    /** @type {AbortController | undefined} */
    #abortController;
    #internals = this.attachInternals();
    /** @returns {RPlayButton} */
    get #buttonEl() {
        return this.shadowRoot.querySelector('button');
    }
    #initDOM() {
        this.shadowRoot.innerHTML = `
            <button>
                <r-icon url="${repeatCurrent}" id="current"></r-icon>
                <r-icon url="${repeatAllIcon}" id="all"></r-icon>
            </button>
        `;
        this.#buttonEl.addEventListener('click', () => {
            player.toggleRepeat();
        }, { signal: this.#abortController.signal });
    }
    #processRepeatChange() {
        eventEmitter.on('repeat change', ({ previousState }) => {
            this.#internals.states.delete(previousState);
            this.#internals.states.add(player.repeat);
        });
    }
}
customElements.define('r-player-repeat-button', RPlayerRepeatButton);
